export const CATALOG_KEY_TO_COLUMN_NAME_MAP = {
    A: 'Nazwa',
    B: 'Nr katalogowy',
    C: 'Kod kreskowy',
    D: 'Typ towaru',
    E: 'VAT',
    F: 'Cena zakupu netto',
    G: 'Cena sprzedaży brutto',
    H: 'Producent',
    I: 'Fotochromowe',
    J: 'Fotochromowe cena',
    K: 'Fotochromowe kolory',
    L: 'Polaryzacyjne',
    M: 'Polaryzacyjne kolory',
    N: 'Przeznaczenie',
    O: 'Materiał szkieł',
    P: 'Konstrukcja soczewki',
    Q: 'Rodzaj soczewki',
    R: 'Barwione',
    S: 'Barwione cena',
    T: 'Dodatkowe usługi',
    U: 'Dodatkowe usługi cena',
    V: 'Wersja',
    W: 'Powłoki',
}

export const EXTENDED_CATALOG_KEY_TO_COLUMN_NAME_MAP = {
    X: 'Rodzaj oprawy',
    Y: 'Indeks',
    Z: 'Średnica od',
    AA: 'Średnica do',
    AB: 'Addycja od',
    AC: 'Addycja do',
    AD: 'Moc pryzmy',
    AE: 'Moc cylindryczna min',
    AF: 'Moc sferyczna min',
    AG: 'Moc sferyczna max',
    AH: 'Moc cylindryczna max',
    AI: 'Moc sferyczna min 2',
    AJ: 'Moc sferyczna max 2',
    AK: 'Przekrój min = Moc sf min + Cyl (moc sf min)',
    AL: 'Przekrój max = Moc sf max + Cyl (moc sf max)',
    AM: 'Krok',
};

export const SURCHARGE_CATALOG_KEY_TO_COLUMN_NAME_MAP = {
    AN: 'Dopłata 1 nazwa',
    AO: 'Dopłata 1 kod',
    AP: 'Dopłata 1 cena netto',
    AQ: 'Dopłata 1 cena brutto',
    AR: 'VAT 1',
    AS: 'Dopłata 2 nazwa',
    AT: 'Dopłata 2 kod',
    AU: 'Dopłata 2 cena netto',
    AV: 'Dopłata 2 cena brutto',
    AW: 'VAT 2',
    AX: 'Dopłata 3 nazwa',
    AY: 'Dopłata 3 kod',
    AZ: 'Dopłata 3 cena netto',
    BA: 'Dopłata 3 cena brutto',
    BB: 'VAT 3',
    BC: 'Dopłata 4 nazwa',
    BD: 'Dopłata 4 kod',
    BE: 'Dopłata 4 cena netto',
    BF: 'Dopłata 4 cena brutto',
    BG: 'VAT 4',
};

export const EXTENDED_COLUMN_ORDER = [
    ...Object.keys(CATALOG_KEY_TO_COLUMN_NAME_MAP),
    ...Object.keys(EXTENDED_CATALOG_KEY_TO_COLUMN_NAME_MAP),
] as (keyof typeof CATALOG_KEY_TO_COLUMN_NAME_MAP | keyof typeof EXTENDED_CATALOG_KEY_TO_COLUMN_NAME_MAP)[];

export const EXTENDED_COLUMN_MAP = {
    ...CATALOG_KEY_TO_COLUMN_NAME_MAP,
    ...EXTENDED_CATALOG_KEY_TO_COLUMN_NAME_MAP,
};

export const FULL_COLUMN_ORDER = [
    ...Object.keys(CATALOG_KEY_TO_COLUMN_NAME_MAP),
    ...Object.keys(EXTENDED_CATALOG_KEY_TO_COLUMN_NAME_MAP),
    ...Object.keys(SURCHARGE_CATALOG_KEY_TO_COLUMN_NAME_MAP),
] as (keyof typeof FULL_COLUMN_MAP)[];

export const FULL_COLUMN_MAP = {
    ...CATALOG_KEY_TO_COLUMN_NAME_MAP,
    ...EXTENDED_CATALOG_KEY_TO_COLUMN_NAME_MAP,
    ...SURCHARGE_CATALOG_KEY_TO_COLUMN_NAME_MAP,
};
